<template lang="html">
  <section class="Hero hero is-success is-bold is-large">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-10 is-offset-1 is-4-desktop is-offset-1-desktop">
          <h1 class="Hero-heading" style="display: flex; align-items: center;">
            Rød Ungdom ønsker å kvitte oss med kapitalismen.
          </h1>
        </div>
        <div class="column is-10 is-offset-1 is-4-desktop is-offset-1-desktop" style="display: flex; align-items: center;">
          <p class="Hero-subHeading">
            Vi lever i en verden med nok mat og ressurser til alle. Likevel finnes det undertrykking, klasseskiller og sult. Rød Ungdom mener kapitalismen er hovedgrunnen til det, fordi makten er så skeivt fordelt. Vi organiserer ungdom til kamp for en rettferdig verden.
          </p>
          <p class="Hero-subHeading">
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'hero-text'
}
</script>

<style lang="sass">
</style>



// WEBPACK FOOTER //
// src/components/HeroText.vue